import { PageModule, PageModuleType } from '@/types/module.types';
import { Post } from '../helpers';
import { Templates } from '@/types/template.types';

interface CreateModuleProps {
  type: PageModuleType;
  eventName: string;
  template: Templates;
  languages: string[];
  baseLanguage: string;
  custom_heading?: string;
}

export function CreatePageModule({
  type,
  eventName,
  template,
  languages,
  baseLanguage,
  custom_heading,
}: CreateModuleProps): Promise<PageModule> {
  return Post({
    path: '/v3/admin/events/page-module',
    body: {
      type,
      eventName,
      template,
      languages,
      baseLanguage,
      custom_heading,
    },
  });
}
